/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enter_Your_New_Secure_PasswordInputs */

const en_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your new secure password below.`)
};

const es_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu nueva contraseña segura a continuación.`)
};

const fr_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez votre nouveau mot de passe sécurisé ci-dessous.`)
};

const de_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib unten dein neues sicheres Passwort ein.`)
};

const ja_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下に新しい安全なパスワードを入力してください。`)
};

const zh_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在下方输入您的新安全密码。`)
};

const ar_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدخل كلمة مرورك الآمنة الجديدة أدناه.`)
};

const id_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan kata sandi baru Anda yang aman di bawah ini.`)
};

const it_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci la tua nuova password sicura qui sotto.`)
};

const ru_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите свой новый надежный пароль ниже.`)
};

const pt_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira a sua nova senha segura abaixo.`)
};

const ko_enter_your_new_secure_password = /** @type {(inputs: Enter_Your_New_Secure_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아래에 안전한 새 비밀번호를 입력하세요.`)
};

/**
* | output |
* | --- |
* | "Enter your new secure password below." |
*
* @param {Enter_Your_New_Secure_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const enter_your_new_secure_password = /** @type {((inputs?: Enter_Your_New_Secure_PasswordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_Your_New_Secure_PasswordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enter_your_new_secure_password(inputs)
	if (locale === "es") return es_enter_your_new_secure_password(inputs)
	if (locale === "fr") return fr_enter_your_new_secure_password(inputs)
	if (locale === "de") return de_enter_your_new_secure_password(inputs)
	if (locale === "ja") return ja_enter_your_new_secure_password(inputs)
	if (locale === "zh") return zh_enter_your_new_secure_password(inputs)
	if (locale === "ar") return ar_enter_your_new_secure_password(inputs)
	if (locale === "id") return id_enter_your_new_secure_password(inputs)
	if (locale === "it") return it_enter_your_new_secure_password(inputs)
	if (locale === "ru") return ru_enter_your_new_secure_password(inputs)
	if (locale === "pt") return pt_enter_your_new_secure_password(inputs)
	return ko_enter_your_new_secure_password(inputs)
});